module.exports = __webpack_public_path__ + "static/editroles1-a73f76eda1f4b896d220c38be2662fbe.png";